<template>
  <div>
    <FilterSelect
      class="block ml-auto mb-8"
      @changeFilter="fetchVideos"
    />
    <div
      :class="$style.aspectRatio"
      class="ar-custom"
    >
      <div
        :class="$style.gridLayout"
        class="grid card overflow-hidden"
      >
        <Video
          ref="video"
          :autoplay="autoplay"
          :class="$style.itemVideo"
          :video="currentVideo"
          @ended="playNextVideo"
        />
        <Item
          v-for="video in videos"
          :active="video.id === currentVideo.id"
          :key="video.id"
          :video="video"
          @selected="changeVideo($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pluralize from 'pluralize'
import { Resource, Type } from '@/src/server/helpers/constants'
import FilterSelect from '@/src/server/components/shared/FilterSelect'
import Item from './Item'
import Video from './Video'

export default {
  components: {
    FilterSelect,
    Item,
    Video,
  },

  data () {
    return {
      autoplay: false,
      currentVideo: {},
      disciplines: [],
      tags: [],
      videos: [],
    }
  },

  computed: {
    manager () {
      return this.$route.query.manager
    },
    filter () {
      const [type, id] = (this.$route.query.only || '').split(':')
      const availableFilters = [
        Type.DISCIPLINE,
        Type.TAG,
      ]

      if (id && availableFilters.includes(type)) {
        return { type, id }
      }
    },
  },

  created () {
    this.fetchVideos(this.filter)
  },

  methods: {
    videoDisciplines (video) {
      return video.relationships.disciplines.data.map((data) => {
        return this.disciplines
          .find((discipline) => discipline.id === data.id)
      })
    },
    videoTags (video) {
      return video.relationships.tags.data.map((data) => {
        return this.tags
          .find((tag) => tag.id === data.id)
      })
    },
    fetchVideos (filter = undefined) {
      if (this.manager) {
        const options = {
          params: {
            query: `${Type.MANAGER}.id = "${this.manager}"`,
            page: {
              size: 3,
            },
            sort: '-published_at',
            include: [
              Resource.DISCIPLINE,
              Resource.TAG,
            ].join(','),
          },
        }

        if (filter) {
          const relationship = Pluralize.plural(filter.type)

          options.params.query += ` AND ${relationship}.id = "${filter.id}"`
        }

        this.$axios(Resource.VIDEO, options)
          .then((response) => {
            this.videos = response.data.data
            const included = response.data.included || []

            this.disciplines = included
              .filter((included) => included.type === Type.DISCIPLINE)
            this.tags = included
              .filter((included) => included.type === Type.TAG)
            this.setCurrentVideoIfNeeded(this.videos)
          })
      }
    },
    setCurrentVideoIfNeeded (videos) {
      if (!this.currentVideo.id) {
        const firstVideo = videos.find(() => true)

        if (firstVideo) {
          this.currentVideo = firstVideo
        }
      }
    },
    changeVideo (video) {
      this.currentVideo = video
      this.autoplay = true
    },
    playNextVideo () {
      const currentVideoIndex = this.videos
        .map((video) => video.id)
        .indexOf(this.currentVideo.id)
      const nextVideo = this.videos[currentVideoIndex + 1]

      if (nextVideo) {
        this.changeVideo(nextVideo)
      }
    },
  },
}
</script>

<style lang="scss" module>
$mediumBreakpoint: 54rem;
$smallBreakpoint: 30rem;

.aspect-ratio {
  padding-top: 100% / 8 * 3;

  @media (max-width: $mediumBreakpoint) {
    padding-top: 100% / 16 * 18;
  }

  @media (max-width: $smallBreakpoint) {
    padding-top: 100% / 16 * 27;
  }
}

.grid-layout {
  grid-template-areas:
    "video  video  item1"
    "video  video  item2"
    "video  video  item3";
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);

  @media (max-width: $mediumBreakpoint) {
    grid-template-areas:
      "video";
      grid-template-columns: 1fr;
      grid-template-rows: 3fr repeat(3, 1fr);
  }

  @media (max-width: $smallBreakpoint) {
      grid-template-rows: 3fr repeat(3, 2fr);
  }
}

.item-video {
  grid-area: video;
}
</style>



// WEBPACK FOOTER //
// src/server/components/Videos/Widget.vue